
const newModel = () => {
    return {
        appId: null,
        appName: null,
        appDomain: null,
        appDescription: null,
        stt: null,
        enabled: null,
        enabledDisplay: null,
    }
}

const newFEModel = () => {
    return {
        appId: null,
        appName: null,
        appDomain: null,
        appDescription: null,
        stt: null,
        enabled: null,
        enabledDisplay: null,
    }
}

const fromJson = (item) => {
    return {
        appId: item.appId,
        appName: item.appName,
        appDomain: item.appDomain,
        appDescription: item.appDescription,
        stt: item.stt,
        enabled: item.enabled,
        enabledDisplay: item.enabled == 1 ? true : false
    }
}

const parseModeltoFEModel = (item) => {
    return {
        appId: item.appId,
        appName: item.appName,
        appDomain: item.appDomain,
        appDescription: item.appDescription,
        stt: item.stt,
        enabled: item.enabled,
        enabledDisplay: item.enabled == 1 ? true : false
    }
}

const errors = () => {
    return {
        appId: null,
        appName: null,
        appDomain: null,
        appDescription: null,
        stt: null,
        enabled: null,
        enabledDisplay: null
    }
}

export const phanHeModel = {
    newModel,
    newFEModel,
    parseModeltoFEModel,
    fromJson,
    errors,
}


